module.exports = __webpack_public_path__ + "ico-crypto-xtz.svg?7e1e4e74cab85258c94df54edf3ac9d0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ico-crypto-xtz.svg
// module id = 1155
// module chunks = 2